import React from 'react';
import PropTypes from 'prop-types';

const TableCell = props => (
    <td className={`ui-table__cell ${props.className || ''}`}>
        <span><span>{props.children}</span></span>
    </td>
);

TableCell.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any
};

export default TableCell;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/TableCell.js